import React, {useEffect, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import Card from "./components/Card";

export default function CustomListLanding({}) {
    const [selectedUniversity, setSelectedUniversity] = useState(null)
    const [selectedCareer, setSelectedCareer] = useState(null)
    const [isInitiaized, setIsInitialized] = useState(false);
    const [leasons, setLeasons] = useState([])
    const [universities, setUniversities] = useState([])
    const [careers, setCareers] = useState([])
    const [loading, setLoading] = useState(false)
    const [query, setQuery] = useState(null)


    async function performSearch(q, u, c) {
        fetch(`/ajax/fetch-courses?query=${q || 'none'}&university=${u || 'none'}&career=${c || 'none'}`)
            .then(r => r.json())
            .then(r => {
                setLeasons(r)
                setLoading(false)
                if(trackEvent) trackEvent('click_on_landing_query', { query: q})
            })
    }

    useEffect(() => {
        if(!isInitiaized) return
        setLoading(true)
        let timeoutCallback = setTimeout(() => {
            performSearch(query, selectedUniversity, selectedCareer)
        }, 500)
        return () => {
            clearTimeout(timeoutCallback)
        }
    }, [query, selectedUniversity, selectedCareer])

    useEffect(() => {
        fetch(`/ajax/fetch-universities`)
            .then(r => r.json())
            .then(r => {
                setUniversities(r)
            })
    }, [])

    useEffect(() => {
        if(!selectedUniversity || selectedUniversity === 'none') return;
        setLoading(true)
        setCareers([])
        fetch(`/ajax/fetch-universities-careers?university=${selectedUniversity}`)
            .then(r => r.json())
            .then(r => {
                setCareers(r)
                setLoading(false)
            })

    }, [selectedUniversity])

    return (
        <Wrapper>
            {/*<Search>*/}
            {/*    <InputSearch  type={'text'} placeholder={'¿Que quieres aprender?'} onChange={v => {*/}
            {/*        const value = v.target.value.length > 0 ? v.target.value : null*/}

            {/*        setQuery(value)*/}
            {/*        if(!isInitiaized) setIsInitialized(true)*/}

            {/*        if (!value) {*/}
            {/*            setSelectedUniversity(null)*/}
            {/*            setSelectedCareer(null)*/}
            {/*        }*/}
            {/*    }}/>*/}
            {/*</Search>*/}
            {isInitiaized && (
                <Filters>
                    <SelectIconContainer>
                        <IconInput src='/images/icons/icon_university.svg' />
                        <SelectCustom
                            defaultValue={selectedUniversity || 'none'}
                            onChange={(v) => {
                                const value = v.target.value === 'none' ? null : v.target.value
                                setSelectedUniversity(value)
                                setSelectedCareer(null)

                                if(trackEvent) trackEvent('click_on_landing_query_selectuniversity', { query: value})
                            }}
                        >
                            <option value={'none'}>Filtra tu universidad</option>
                            {universities.map((u) => {
                                return (
                                    <option value={u.slug} key={`option_universitiy_${u.slug}`}>{u.name}</option>)
                            })}
                        </SelectCustom>
                    </SelectIconContainer>

                    <SelectIconContainer>
                        <IconInput src='/images/icons/icon_book.svg' />

                    <SelectCustom
                        defaultValue={'none'}
                        onChange={(v) => {
                            const value = v.target.value === 'none' ? null : v.target.value
                            setSelectedCareer(value)
                            if(trackEvent) trackEvent('click_on_landing_select_career', { query: value})
                        }}
                    >
                        <option value={'none'}>Selecciona tu carrera</option>
                        {careers.map((u) => {
                            return (
                                <option value={u.slug} key={`option_career_${u.slug}`}>{u.name}</option>)
                        })}
                    </SelectCustom>
                    </SelectIconContainer>
                </Filters>
            )}

            {(isInitiaized && loading) && (<LoadingContainer isLoading={loading}><img alt={'loading'} src='/images/loader.svg' /></LoadingContainer>)}


            {(isInitiaized && !loading) && (
                <WrapperCourses>
                    {leasons.slice(0, 9).map((lesaon, indx) => {
                        return (
                            <Card
                                url={`/course/${lesaon.course}/lesson/${lesaon.slug}`}
                                key={`leason_card_${indx}`}
                                name={lesaon.name}
                                career={lesaon.career_name}
                                description={lesaon.description}
                                university={lesaon.university_name}
                                block={lesaon.block_name}
                                module={lesaon.module_name}
                                duration={lesaon.duration}

                            />

                        )
                    })}

                    {leasons.length === 0 &&  (<div>No hay resultados</div>)}
                </WrapperCourses>
            )}

        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding-top: 48px;
    padding-left: 20%;
    padding-right: 20%;
    @media only screen and (max-width: 600px) {
        padding-left: 5%;
        padding-right: 5%;
    }
`

const LoadingContainer = styled.div`
    display: ${props => props.isLoading === true ? 'flex' : 'none'};
    padding-top: 64px;
    flex-direction: row;
    justify-content: center
`

const Filters = styled.div`
    padding-top: 12px;
    padding-bottom: 12px;
    display: flex;
    flex-direction: row;

    justify-content: center;
    & select {
        margin: 8px;
    }

    @media only screen and (max-width: 600px) {
         flex-direction: column;
    }
`

const SelectIconContainer = styled.div`
    display: flex;
    flex-direction: row;
`

const IconInput = styled.img`
    position: absolute;
    margin-left: 16px;
    margin-top: 25px;
    width: 30px;
    height: 30px;
`

const SelectCustom = styled.select`
    padding-left: 50px;
     @media only screen and (max-width: 600px) {
         width: 100%;
    }
`


const Search = styled.div`

`

const InputSearch = styled.input`
    width: 100%;
`

const WrapperCourses = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
`


if (document.getElementsByTagName('custom-list-landing-component')) {

    const elements = document.getElementsByTagName('custom-list-landing-component')

    for (let elm of elements) {
        ReactDOM.render(<CustomListLanding />, elm)
    }
    // ReactDOM.render(<Example />, document.getElementById('example'));
}
